import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RoutesMapper } from '../routes-mapper';
import { SsoAuthService } from '../services/apis/sso-auth.service';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const auth = inject(SsoAuthService);

  if (auth.hasSessionFlag()) {
    return true;
  }

  router.navigate([RoutesMapper.LOGIN]);
  return false;
};
